var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "order-tmp-caption",
        staticStyle: {
          "font-size": "15px",
          color: "#1a1a1a",
          "font-weight": "600",
          "text-align": "center",
          padding: "15px 0"
        }
      },
      [_vm._v(_vm._s(_vm.servcWorkAddItemResult.name))]
    ),
    _vm._v(" "),
    _c(
      "table",
      {
        staticClass: "simple-tbl",
        staticStyle: {
          width: "100%",
          "table-layout": "fixed",
          "border-collapse": "collapse",
          "font-size": "12px"
        }
      },
      [
        _c(
          "tbody",
          { staticClass: "body" },
          _vm._l(_vm.servcWorkAddItemResult.tableUpItemList, function(
            tableUpItem,
            index
          ) {
            return _c("tr", { staticClass: "row", attrs: { align: "left" } }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "none",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [_vm._v(_vm._s(tableUpItem.contentFist) + ":")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "none",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [_vm._v(_vm._s(tableUpItem.remarkFist))]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "none",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [_vm._v(_vm._s(tableUpItem.contentTwo))]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "none",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [_vm._v(_vm._s(tableUpItem.remarkTwo))]
              )
            ])
          })
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "table",
      {
        staticClass: "simple-tbl",
        staticStyle: {
          width: "100%",
          "table-layout": "fixed",
          "border-collapse": "collapse",
          "border-spacing": "2px",
          color: "#666",
          "font-size": "12px"
        }
      },
      [
        _c(
          "tbody",
          { staticClass: "body" },
          _vm._l(_vm.servcWorkAddItemResult.tableItemList, function(tableItem) {
            return _c("tr", { staticClass: "row", attrs: { align: "left" } }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  },
                  attrs: { colspan: "2" }
                },
                [_vm._v(_vm._s(tableItem.content))]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  },
                  attrs: { colspan: "2" }
                },
                [_vm._v(_vm._s(tableItem.remark))]
              )
            ])
          })
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "table",
      {
        staticClass: "simple-tbl",
        staticStyle: {
          width: "100%",
          "table-layout": "fixed",
          "border-collapse": "collapse",
          "font-size": "12px"
        }
      },
      [
        _c(
          "tbody",
          { staticClass: "body" },
          _vm._l(_vm.servcWorkAddItemResult.tableDwItemList, function(
            tableDwItem,
            index
          ) {
            return _c("tr", { staticClass: "row", attrs: { align: "left" } }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "none",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [_vm._v(_vm._s(tableDwItem.contentFist) + ":")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "none",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [_vm._v(_vm._s(tableDwItem.remarkFist))]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "none",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [_vm._v(_vm._s(tableDwItem.contentTwo))]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "none",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [_vm._v(_vm._s(tableDwItem.remarkTwo))]
              )
            ])
          })
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22890017", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22890017","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/workVoucher/ServcWorkAddItem.vue
// module id = 1868
// module chunks = 1